import { Container, Row, Col, Card, CardBody, CardHeader, Table, Badge } from 'reactstrap';
import { H3 } from 'AbstractElements';
import { useSelector } from 'react-redux';
import CurrencyFormatter from 'Component/Common/Formatter/CurrencyFormatter';
import { useNavigate } from 'react-router-dom';
import BranchDoctor from './BranchDoctor';

const BranchTreatment = () => {
    const currentBranch = useSelector((state) => state.branch.currentBranch);
    // console.log(currentBranch, 'currentBranch');
    const history = useNavigate();
    

    return (
        <Col>
            <Card>
                <CardHeader className="pb-3 text-center">
                    <H3>Daftar Perawatan di {currentBranch?.name}</H3>
                </CardHeader>
                <Col sm="12" lg="12" xl="12">
                    <div className="table-responsive" style={{ minHeight: "160px" }}>
                        {currentBranch?.treatment?.length > 0 ? (
                            <Table className="table-hover table-border-vertical">
                                <thead className="bg-primary">
                                    <tr>
                                        <th scope="col" className="sticky-col-number" style={{ width: "15px" }}>
                                            #
                                        </th>
                                        <th scope="col" className="sticky-col-name">
                                            Nama Perawatan
                                        </th>
                                        <th scope="col" style={{ width: "100px" }}>
                                            Biaya
                                        </th>
                                        <th scope="col" className="text-center" style={{ width: "15px" }}>
                                            Aksi
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentBranch?.treatment.map((item, i) => (
                                        <tr key={item.id}>
                                            <th className="sticky-col-number" scope="row" style={{ verticalAlign: "top" }}>
                                                {i + 1}
                                            </th>
                                            <td className="sticky-col-name">{item.name}</td>
                                            <td style={{ maxWidth: "auto", whiteSpace: "nowrap", overflow: "hidden" }}>
                                                <CurrencyFormatter amount={item.price} />
                                            </td>
                                            <td>
                                                <div className="d-flex">
                                                    <button
                                                        className="btn btn-primary"
                                                        style={{ padding: "4px 8px", fontSize: "12px" }}
                                                        onClick={() => history(`${process.env.PUBLIC_URL}/treatment/edit/${item.id}`)}
                                                    >
                                                        <i className="fa fa-pencil"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        ) : (
                            <div className="text-center p-4">
                                <Badge color="danger">Belum ada data perawatan!</Badge>
                            </div>
                        )}
                    </div>
                </Col>
            </Card>
        </Col>
    );
};

export default BranchTreatment;
